import { RightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { LangText } from '@/components/LangText'

type BreadcrumbProps = {
  currentKey: string
}

export const Breadcrumb = ({ currentKey }: BreadcrumbProps) => (
  <nav className="w-full bg-white" style={{ height: 50 }} aria-label="Breadcrumb">
    <div className="mx-auto flex h-full w-[1200px] items-center text-[20px]">
      <Link to="/" className="text-primary transition-opacity hover:opacity-80">
        <LangText lngKey="common.breadcrumb.home" />
      </Link>
      <span className="mx-[10px] text-[12px] text-[#18181A]" aria-hidden>
        <RightOutlined />
      </span>
      <LangText lngKey={currentKey} className="font-normal text-[#18181A]" />
    </div>
  </nav>
)
